import React from 'react'
import { useState } from "react";

function CategorySlider({ categoryData, activeCatId, setActiveCatId }) {
    const [imgLoaded, setImgLoaded] = useState({});

    const initials = (str = "") =>
        str
            .split(" ")
            .map((s) => s[0])
            .join("")
            .toUpperCase();

    return (
        <div className="bg-white border-bottom px-3 py-3 ">
            <div
                className="d-flex overflow-auto gap-3 pb-2"
                style={{
                    scrollSnapType: "x mandatory",
                    WebkitOverflowScrolling: "touch",
                }}
            >
                <CategoryChip
                    img="https://ncapi.narayaniconcept.com/assets/Default/product.png"
                    label="All"
                    active={activeCatId === "ALL"}
                    onClick={() => setActiveCatId("ALL")}
                    loaded={imgLoaded.ALL}
                    onImgLoad={() => setImgLoaded((p) => ({ ...p, ALL: true }))}
                />

                {categoryData.map((cat) => (
                    <CategoryChip
                        key={cat.id}
                        img={cat.image}
                        label={cat.name}
                        active={activeCatId === cat.id}
                        onClick={() => setActiveCatId(cat.id)}
                        loaded={imgLoaded[cat.id]}
                        onImgLoad={() =>
                            setImgLoaded((p) => ({ ...p, [cat.id]: true }))
                        }
                        fallback={initials(cat.name)}
                    />
                ))}
            </div>
        </div>
    );
}

function CategoryChip({
                          img,
                          label,
                          active,
                          onClick,
                          loaded,
                          onImgLoad,
                          fallback,
                      }) {
    return (
        <button
            className={
                `"d-flex flex-column align-items-center",
                "bg-transparent border-0 p-2 rounded-pill",
                "transition-all",
                ${active && "shadow-sm bg-primary bg-opacity-10 scale-105"}`
            }
            style={{
                minWidth: 76,
                scrollSnapAlign: "start",
                transform: active ? "scale(1.05)" : undefined,
            }}
            onClick={onClick}
        >
            <div
                className="rounded-circle overflow-hidden bg-light d-flex align-items-center justify-content-center"
                style={{ width: 60, height: 60 }}
            >
                {!loaded && (
                    <span className="text-muted fw-bold">{fallback}</span>
                )}
                <img
                    src={img}
                    alt={label}
                    width={60}
                    height={60}
                    onLoad={onImgLoad}
                    onError={() => onImgLoad()}
                    style={{
                        objectFit: "cover",
                        display: loaded ? "block" : "none",
                    }}
                />
            </div>

            <small
                className={`
                    "fw-semibold mt-1 text-center lh-sm",
                    ${active ? "text-white" : "text-dark"}
                `}
                style={{
                    fontSize: 12,
                    WebkitLineClamp: 2,
                    display: "-webkit-box",
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden",
                    maxWidth: 64,
                }}
            >
                {label}
            </small>
        </button>
    );
}
export default CategorySlider;